export default {
  'file': {
    iconName: 'kanbo-16-go-to-source',
    formattedMessageId: 'DOCUMENT_ACTION_FILE',
    onClick: (action) => {
      window.open(action.url, '_blank')
    }
  },
  'online': {
    iconName: 'kanbo-16-public-1',
    formattedMessageId: 'DOCUMENT_ACTION_ONLINE',
    onClick: (action) => {
      window.open(action.url, '_blank')
    }
  },
  'office': {
    iconName: 'kanbo-16-full-screan',
    formattedMessageId: 'DOCUMENT_ACTION_OFFICE',
    onClick: (action) => {
      window.open(action.url, '_blank')
    }
  },
  'download': {
    iconName: 'kanbo-16-download',
    formattedMessageId: 'DOCUMENT_ACTION_DOWNLOAD',
    onClick: (action) => {
      window.open(action.url, '_blank')
    }
  },
}
